import * as React from 'react';
import cx from 'classnames';
import { Search } from './search';
import { Box } from '@dropbox/dig-foundations';
/**
 * The main job of this component is to provide a 'container' of styles that work
 * consistently cross-product. Given this definition we're strictly "forcing" order of
 * the components provided.
 */
export const Wrapper = ({ children, isSticky = true, isDietHeader, hasNoBottomBorder = false, shouldAlwaysShowLogo = false, className, ...rest }) => {
    // Needed for diet header to visually hide the logo, but keep it for screen readers.
    const hasSearch = !shouldAlwaysShowLogo &&
        !!React.Children.toArray(children).find((child) => React.isValidElement(child) && child.type === Search);
    return (React.createElement(Box, { as: "header", className: cx('dpc-GlobalHeader', className, {
            'dpc-GlobalHeader--isSticky': !!isSticky,
            'dpc-GlobalHeader--isDietHeader': !!isDietHeader,
            'dpc-GlobalHeader--hasSearch': hasSearch,
            'dpc-GlobalHeader--hasNoBottomBorder': hasNoBottomBorder,
            'dpc-GlobalHeader--shouldAlwaysShowLogo': shouldAlwaysShowLogo,
        }), ...rest }, children));
};
Wrapper.displayName = 'Wrapper';
